<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-at`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M37.5 32c-2.056 0-3.92-.883-5.274-2.312A9.989 9.989 0 0124 34c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10c0 2.21 1.567 4 3.5 4 1.95 0 3.12-1.246 3.513-3.738l.158-1.093c.096-.699.158-1.339.158-2.306C41.329 13.993 34.328 6 24 6S6.04 13.672 6.04 24 13.671 42.022 24 42.022c3.464 0 6.694-1.166 9.472-2.865l.36-.224c.088-.056.196-.127.324-.212a1 1 0 011.052-.034l2.256 1.297a.811.811 0 01.174 1.272l-.078.07A21.906 21.906 0 0124 46C11.85 46 2 36.15 2 24S11.85 2 24 2c12.024 0 21.123 8.353 21.31 18.541l.002.813c-.009.49-.056 1.28-.27 3.098C44.591 28.652 41.498 32 37.5 32zM24 30a6 6 0 100-12 6 6 0 000 12z"/></svg>
</template>
<script>

export default {
  name: 'IconAt',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
